import { useEffect } from "react";

const SITE = "https://dmznormandie.fr";

export default function SEO({ title, description, path = "/", jsonLd = null, robots = "index,follow" }) {
  useEffect(() => {
    document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, keyVal] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(key, keyVal.replace(/"/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[name="robots"]', "content", robots);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", `${SITE}${path}`);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:image"]', "content", `${SITE}/social/dmz-presentation-facebook.png`);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE}${path}`);

    let ldEl = document.getElementById("jsonld-page");
    if (ldEl) ldEl.remove();
    if (jsonLd) {
      ldEl = document.createElement("script");
      ldEl.id = "jsonld-page";
      ldEl.type = "application/ld+json";
      ldEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ldEl);
    }
  }, [title, description, path, jsonLd, robots]);

  return null;
}
